import React, { useEffect, useState } from "react";
import img1 from "../Leads/download123.png";
// import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useParams } from "react-router-dom";
import SetARemind from "./SetARemind";
import {
  Select as TagSelector,
  Avatar,
  Tag,
  Spin,
  Empty,
  message,
  Input,
  DatePicker,
  Select,
  Tooltip,
} from "antd";
import Table from "../../../../core/pagination/datatable";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import dayjs from "dayjs";

import axios from "axios";
import { CalendarOutlined } from "@ant-design/icons";
// import { UserOutlined } from "@ant-design/icons";
import NewCustomer from "../Customers/NewCustomer";
// import { Option } from "antd/es/mentions";
import NewTask from "../Tasks/NewTask";
import TaskDetailDrawer from "../Tasks/TaskDetailDrawer";
import FilesDrawer from "../Tasks/FilesDrawer";

const ViewLeads = () => {
  const { id } = useParams();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const [proposalStatusOptions, setProposalStatusOptions] = useState([]);

  const getProposalStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.ProposalStatus,
        }));

        setProposalStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const proposalStatusColors = {
    Sent: "green",
    Pending: "orange",
    Declined: "red",
    Draft: "blue",
    Accepted: "success",
    Default: "default",
  };

  const truncateString = (inputString) => {
    if (inputString.length > 40) {
      return inputString.slice(0, 40) + "...";
    }
    return inputString;
  };

  const proposalColumns = [
    {
      title: "ProposalNo",
      dataIndex: "PrefixNumber",

      render: (text, record) => (
        <Link
          to={`/crm/view/proposal`}
          state={{ record }}
          className="text-decoration-none"
        >
          <Tag
            color={proposalStatusColors[status] || proposalStatusColors.Default}
            bordered={false}
            style={{
              padding: "4px 12px",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {text}
          </Tag>
        </Link>
      ),
    },

    {
      title: "Proposal",
      dataIndex: "proposal_to",

      render: (_, record) => {
        const initials = record.proposal_to
          ?.split(" ")
          .slice(0, 2)
          .map((x) => x[0])
          .join("")
          .toUpperCase();

        const avatarColors = {
          green: {
            bg: "#E8F5E9",
            color: "#2E7D32",
          },
          orange: {
            bg: "#FFF3E0",
            color: "#EF6C00",
          },
          red: {
            bg: "#FFEBEE",
            color: "#C62828",
          },
          blue: {
            bg: "#E3F2FD",
            color: "#1565C0",
          },
        };
        const avatarStyle =
          proposalStatusColors[record.status] === "green"
            ? avatarColors.green
            : proposalStatusColors[record.status] === "orange"
              ? avatarColors.orange
              : proposalStatusColors[record.status] === "red"
                ? avatarColors.red
                : avatarColors.blue;
        return (
          <div className="d-flex align-items-start">
            <Avatar
              size={40}
              style={{
                backgroundColor: avatarStyle.bg,
                color: avatarStyle.color,
                fontWeight: 700,
                fontSize: 17,
              }}
            >
              {initials}
            </Avatar>

            <div className="ms-3">
              <div className="fw-semibold text-dark text-decoration-none">
                {truncateString(record.subject)}
              </div>

              <div className="text-muted small">
                <i className="fa-regular fa-user me-2"></i>
                {record.proposal_to}
              </div>
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",

      render: (amount) => (
        <>
          <div className="fw-semibold">
            <i className="fa-solid fa-indian-rupee-sign text-success me-2"></i>
            {amount}
          </div>
        </>
      ),
    },

    {
      title: "Timeline",

      render: (_, record) => (
        <>
          <div>
            <i className="fa-regular fa-calendar me-2 text-primary"></i>

            {dayjs(record.datecreated).format("DD-MM-YYYY") || "-"}
          </div>

          <small className="text-muted text-danger">
            <i className="fa-regular fa-clock me-2 text-danger"></i>
            {dayjs(record.open_till).format("DD-MM-YYYY") || "-"}
          </small>
        </>
      ),
    },

    // {
    //   title: "Project",
    //   dataIndex: "project",
    //   width: 220,
    //   render: (text) => (
    //     <Tag
    //       color="blue"
    //       bordered={false}
    //       style={{
    //         borderRadius: 20,
    //         padding: "4px 12px",
    //       }}
    //     >
    //       {text || "N/A"}
    //     </Tag>
    //   ),
    // },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";
            case "Open":
              return "#0dcaf0";
            case "Revised":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              proposalStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 100 }}
            options={proposalStatusOptions}
            onChange={(value) => {
              updateProposalStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = proposalStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",

      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/view/proposal`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/proposal/${record.id}`}
                state={{
                  proposalId: record.id,
                }}
                className="dropdown-item"
              >
                <Edit className="text-primary me-2" />
                Edit
              </Link>
            </li>

            <li>
              <Link className="dropdown-item">
                <Trash2 className="text-danger me-2" />
                Delete
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to={`/crm/update/proposal/${record.id}`}
                state={{
                  proposalId: record.id,
                }}
                className="me-2 p-2  shadow-sm"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [activeTab, setActiveTab] = useState("profile");
  const [isEditingProfile, setIsEditingProfile] = useState(false);

  const handleEditClick = () => {
    setIsEditingProfile((prev) => !prev);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    // Exit edit mode when leaving Profile
    if (tab !== "profile") {
      setIsEditingProfile(false);
    }
  };

  const [viewLeadLoading, setViewLeadLoading] = useState(false);
  const [leadsData, setLeadsData] = useState({});

  console.log(leadsData, "leadssssssssssssss");
  const [proposals, setProposals] = useState([]);

  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [noteData, setNoteData] = useState({
    description: "",
    date_contacted: null,
  });
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editNoteData, setEditNoteData] = useState({
    description: "",
  });
  const [updateNoteLoading, setUpdateNoteLoading] = useState(false);

  const [reminders, setReminders] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);

  const [editingReminderId, setEditingReminderId] = useState(null);

  const [reminderData, setReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [editReminderData, setEditReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
    isnotified: 0,
  });

  console.log(viewLeadLoading);

  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: id,
    name: "",
    company: "",
    description: "",
    country: "",
    zip: "",
    city: "",
    state: "",
    address: "",
    assigned: "",
    status: "",
    source: "",
    addedfrom: "",
    email: "",
    website: "",
    phonenumber: "",
    default_language: "",
    title: "",
    leadvalue: "",
    lastcontact: "",
  });

  console.log(formData, "formmmmdataaaaaaaaaa");

  const [loading, setLoading] = useState(false);

  const fetchProposals = async (relId) => {
    setLoading(true);
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/GetProposalsByRelId?relID=${relId}&&RelType=lead&Status=0`,
      );

      const data = await response.json();

      if (data.Status) {
        setProposals(data.ResultData || []);
      } else {
        setProposals([]);
      }
    } catch (error) {
      console.error("Error fetching proposals:", error);
      setProposals([]);
    } finally {
      setLoading(false);
    }
  };

  const updateProposalStatus = async (proposalId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}proposal/UpdateProposalStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: proposalId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        fetchProposals(id); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchProposals(id);
      fetchNotes();
      fetchReminders();
      getProposalStatuses();
    }
  }, [id]);

  const fetchNotes = async () => {
    try {
      setNotesLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}notes/GetNotes?rel_id=${id}&rel_type=Lead`,
      );

      const data = await response.json();

      if (data.Status) {
        setNotes(data.ResultData || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
      setNotes([]);
    } finally {
      setNotesLoading(false);
    }
  };

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}reminder/GetReminders?rel_id=${id}&rel_type=Lead&staffid=0`,
      );

      const data = await response.json();

      if (data.Status) {
        setReminders(data.ResultData || []);
      } else {
        setReminders([]);
      }
    } catch (error) {
      console.error(error);
      setReminders([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.ResultData) {
        setStaffList(data.ResultData);
      } else {
        setStaffList([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    } finally {
      setStaffLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleAddNote = async () => {
    if (!noteData.description.trim()) {
      message.warning("Please enter a note.");
      return;
    }

    try {
      setAddNoteLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}notes/AddNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rel_id: id,
          rel_type: "Lead",
          description: noteData.description,
          addedfrom: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        message.success(data.Message);

        setNoteData({
          description: "",
          date_contacted: null,
        });

        fetchNotes();
      } else {
        message.error(data.Message);
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong.");
    } finally {
      setAddNoteLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getLeadById = async () => {
    setViewLeadLoading(true);

    try {
      const response = await fetch(
        `${BASE_CRM_URL}leads/GetLeadById?LeadId=${id}`,
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log(data, "View Lead Details");

      if (data.Status) {
        setLeadsData(data.ResultData);
      } else {
        setLeadsData([]);
        Swal({
          title: "Warning",
          text: data.Message || "Lead not found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Error fetching lead:", error);
    } finally {
      setViewLeadLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getLeadById();
    }
  }, [id]);

  const handleEditNote = (note) => {
    setEditingNoteId(note.id);

    setEditNoteData({
      description: note.description,
    });
  };

  const handleCancelEdit = () => {
    setEditingNoteId(null);

    setEditNoteData({
      description: "",
    });
  };

  const handelCancelNote = () => {
    setNoteData({
      description: "",
    });
  };

  const handleUpdateNote = async () => {
    if (!editNoteData.description.trim()) {
      message.warning("Please enter a note.");
      return;
    }

    try {
      setUpdateNoteLoading(true);

      const response = await fetch(`${BASE_CRM_URL}notes/UpdateNote`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingNoteId,
          description: editNoteData.description,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        message.success(data.Message);

        setEditingNoteId(null);

        setEditNoteData({
          description: "",
        });

        fetchNotes();
      } else {
        message.error(data.Message);
      }
    } catch (error) {
      console.error(error);
      message.error("Something went wrong.");
    } finally {
      setUpdateNoteLoading(false);
    }
  };

  const handleAddReminder = async () => {
    if (!reminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    if (!reminderData.date) {
      Swal.fire({
        icon: "warning",
        title: "Reminder Date Required",
        text: "Please select reminder date.",
      });
      return;
    }

    try {
      setAddReminderLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: reminderData.description,
          date: dayjs(reminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          rel_id: id,
          rel_type: "Lead",
          staff: reminderData.staff,
          creator: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        window.dispatchEvent(new Event("refresh-notifications"));

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminderId(reminder.id);

    setEditReminderData({
      description: reminder.description,
      date: dayjs(reminder.date),
      staff: reminder.staff,
      isnotified: Number(reminder.isnotified) === 1 ? 1 : 0,
    });
  };

  const handleCancelReminderEdit = () => {
    setEditingReminderId(null);

    setEditReminderData({
      description: "",
      date: null,
      staff: userId,
      isnotified: 0,
    });
  };

  const handelCancelreminder = () => {
    setReminderData({
      description: "",
      date: null,
      staff: userId,
    });
  };

  const handleUpdateReminder = async () => {
    if (!editReminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    try {
      setUpdateReminderLoading(true);

      const response = await fetch(`${BASE_CRM_URL}reminder/UpdateReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingReminderId,
          description: editReminderData.description,
          date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          staff: editReminderData.staff,
          isnotified: Number(editReminderData.isnotified),
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setEditingReminderId(null);

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setUpdateReminderLoading(false);
    }
  };

  const handleDeleteReminder = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this reminder?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#e40d22",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
      const response = await fetch(`${BASE_CRM_URL}reminder/DeleteReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
        }),
      });

      const data = await response.json();

      if (data.Status || data.status) {
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: data.message || "Reminder deleted successfully.",
          timer: 1500,
          showConfirmButton: false,
        });

        // Refresh reminder list
        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.message || "Failed to delete reminder.",
        });
      }
    } catch (error) {
      console.error("Delete reminder error:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while deleting the reminder.",
      });
    }
  };

  //EditProfile integration

  const [statusData, setStatusData] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);

  const [sorceData, setSorceData] = useState([]);
  const [sourceLoading, setSourceLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);
  console.log(countryLoading);

  const [updating, setUpdating] = useState(false);
  const [staffData, setStaffData] = useState([]);
  // const [staffLoading, setStaffLoading] = useState(false);

  const getStatusDropDown = async () => {
    setStatusLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadStatus`);

      if (response.data.Status) {
        setStatusData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No status data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("status API Error:", error);
    } finally {
      setStatusLoading(false);
    }
  };

  const getSourceDropDown = async () => {
    setSourceLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadSources`);

      if (response.data.Status) {
        setSorceData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No source data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Source API Error:", error);
    } finally {
      setSourceLoading(false);
    }
  };

  const getCountries = async () => {
    setCountryLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}GetCountries`);

      if (response.data.Status) {
        setCountries(response.data.ResultData || []);
      }
    } catch (error) {
      console.error("Country API Error:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  const getStaffDropDown = async () => {
    setStaffLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}staff/GetStaffDropdown`);

      if (response.data.Status) {
        setStaffData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No staff data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Leads API Error:", error);
    } finally {
      setStaffLoading(false);
    }
  };

  const assignedOptions = staffData.map((staff) => ({
    value: staff.staffid,
    label: staff.firstname,
  }));

  const statusOptions = statusData.map((status) => ({
    value: status.id,
    label: status.name,
  }));

  const sourceOptions = sorceData.map((sorce) => ({
    value: sorce.SourceId,
    label: sorce.SourceName,
  }));

  const countryOptions = countries.map((country) => ({
    value: country.country_id,
    label: country.short_name,
  }));

  useEffect(() => {
    getStatusDropDown();
    getSourceDropDown();
    getCountries();
    getStaffDropDown();
  }, []);

  useEffect(() => {
    if (leadsData && Object.keys(leadsData).length > 0) {
      setFormData({
        id: leadsData.id || "",
        name: leadsData.name || "",
        company: leadsData.company || "",
        description: leadsData.description || "",
        country: leadsData.country || "",
        zip: leadsData.zip || "",
        city: leadsData.city || "",
        state: leadsData.state || "",
        address: leadsData.address || "",
        assigned: leadsData.assigned || "",
        status: leadsData.status || "",
        source: leadsData.source || "",
        addedfrom: leadsData.addedfrom || "",
        email: leadsData.email || "",
        website: leadsData.website || "",
        phonenumber: leadsData.phonenumber || "",
        default_language: leadsData.default_language || "",
        leadvalue: leadsData.lead_value || "",
        title: leadsData.title || "",
        lastcontact: leadsData.lastcontact || "",
      });
    }
  }, [leadsData]);

  const updateLead = async (e) => {
    setUpdating(true);
    e.preventDefault();

    const payload = {
      id: formData.id,
      name: formData.name,
      company: formData.company,
      title: formData.title,
      description: formData.description,
      email: formData.email,
      phonenumber: formData.phonenumber,
      website: formData.website,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      country: formData.country,
      assigned: formData.assigned,
      status: formData.status,
      source: formData.source,
      addedfrom: userId,
      default_language: formData.default_language,
      lead_value: formData.leadvalue,
    };

    console.log("Update Payload:", payload);

    try {
      const response = await axios.post(
        `${BASE_CRM_URL}leads/UpdateLead`,
        payload,
      );

      console.log("Update Response:", response.data);

      if (response.data.Status) {
        Swal.fire({
          title: "Success",
          text: response.data.message || "Lead updated successfully.",
          icon: "success",
          button: "OK",
        }).then(() => {
          setIsEditingProfile(false);
          getLeadById(id);
        });
      } else {
        Swal.fire({
          title: "Warning",
          text: response.data.message || "Unable to update lead.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Update Error:", error.response?.data || error);
    } finally {
      setUpdating(false);
    }
  };

  //active log integration
  const [activityLog, setActivityLog] = useState([]);

  console.log(activityLog, "activityyyyyyyyyyy");
  const [activityLoading, setActivityLoading] = useState(false);
  const getLeadActivityLog = async (leadid) => {
    try {
      setActivityLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}leads/GetLeadActivitylog?LeadId=${leadid}`,
      );

      if (response.data.Status) {
        setActivityLog(response.data.ResultData || []);
      } else {
        setActivityLog([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setActivityLoading(false);
    }
  };
  useEffect(() => {
    getLeadActivityLog(id);
  }, []);

  //Lead task integration part

  const [taskStatusOptions, setTaskStatusOptions] = useState([]);
  const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
  const [updatingStatusTaskId, setUpdatingStatusTaskId] = useState(null);

  const [priorityOptions, setPriorityOptions] = useState([]);
  const [priorityOptionsLoading, setPriorityOptionsLoading] = useState(false);
  const [updatingPriorityTaskId, setUpdatingPriorityTaskId] = useState(null);
  const [filesDrawerOpen, setFilesDrawerOpen] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const avatarColors = [
    { background: "#E7F1FF", color: "#0D6EFD" },
    { background: "#E8F8F0", color: "#198754" },
    { background: "#FFF4DE", color: "#FF9800" },
    { background: "#FDECEC", color: "#DC3545" },
    { background: "#E8F7FA", color: "#0DCAF0" },
    { background: "#F3E8FF", color: "#6F42C1" },
  ];

  // const normalizeText = (value) =>
  //   String(value || "")
  //     .toLowerCase()
  //     .replace(/[\s-]/g, "");

  // const getPriorityColorKey = (priorityName) => {
  //   switch (normalizeText(priorityName)) {
  //     case "low":
  //       return "success";

  //     case "medium":
  //       return "primary";

  //     case "high":
  //       return "warning";

  //     case "urgent":
  //       return "danger";

  //     default:
  //       return "secondary";
  //   }
  // };

  // const getPriorityOptionById = (priorityId) =>
  //   priorityOptions.find(
  //     (option) => Number(option.priorityid) === Number(priorityId),
  //   );

  const fetchTaskStatuses = async () => {
    try {
      setStatusOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}tasks/GetTaskStatus`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      console.log("STATUS API:", result);

      setTaskStatusOptions(
        Array.isArray(result?.ResultData) ? result.ResultData : [],
      );
    } catch (error) {
      console.error("Error fetching task statuses:", error);
      setTaskStatusOptions([]);
    } finally {
      setStatusOptionsLoading(false);
    }
  };

  const fetchPriorities = async () => {
    try {
      setPriorityOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetPriorities`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      console.log("PRIORITY API:", result);

      setPriorityOptions(
        Array.isArray(result?.ResultData) ? result.ResultData : [],
      );
    } catch (error) {
      console.error("Error fetching priorities:", error);
      setPriorityOptions([]);
    } finally {
      setPriorityOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchTaskStatuses();
    fetchPriorities();
  }, []);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (text, record) => (
        <Tooltip title={text}>
          <span
            onClick={(event) => {
              event.preventDefault();
              openTaskDetail("view", record);
            }}
          >
            {text?.length > 45 ? `${text.substring(0, 45)}...` : text || "N/A"}
          </span>
        </Tooltip>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",

      render: (status, record) => {
        const isUpdating = updatingStatusTaskId === record.id;

        const getStatusColor = (statusName) => {
          switch (
            String(statusName || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "complete":
            case "completed":
              return "#198754";

            case "testing":
              return "#0d6efd";

            case "inprogress":
              return "#ffc107";

            case "notstarted":
              return "#dc3545";

            case "awaitingfeedback":
              return "#0dcaf0";

            default:
              return "#6c757d";
          }
        };

        const statusSelectOptions = taskStatusOptions.map((option) => ({
          value: option.Id,
          label: option.Status,
        }));

        const selectedStatus = taskStatusOptions.find(
          (option) => Number(option.Id) === Number(record.statusId),
        );

        const statusColor = getStatusColor(selectedStatus?.Status || status);

        return (
          <Select
            value={selectedStatus ? record.statusId : undefined}
            size="small"
            loading={statusOptionsLoading || isUpdating}
            disabled={statusOptionsLoading || isUpdating}
            style={{
              width: 125,
            }}
            styles={{
              selector: {
                border: `1px solid ${statusColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={statusSelectOptions}
            onChange={(newStatusId) => {
              if (Number(newStatusId) === Number(record.statusId)) {
                return;
              }

              updateTaskStatus(record.id, newStatusId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getStatusColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: statusColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedStatus?.Status || status || "Select Status"}
                </span>
              </div>
            )}
          />
        );
      },
    },
    {
      title: "Start Date",
      dataIndex: "startdate",
      sorter: (a, b) => new Date(a.startdate) - new Date(b.startdate),
      render: (date) => (
        <span>
          {/* <CalendarOutlined className="me-1 text-primary" /> */}
          {date ? dayjs(date).format("DD-MM-YYYY") : "N/A"}
        </span>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "duedate",
      sorter: (a, b) => new Date(a.duedate) - new Date(b.duedate),
      render: (date) => (
        <span>
          {/* <CalendarOutlined className="me-1 text-danger" /> */}
          {date ? dayjs(date).format("DD-MM-YYYY") : "N/A"}
        </span>
      ),
    },

    {
      title: "Assigned",
      dataIndex: "staff_names",

      render: (assignedTo) => {
        const staffList = Array.isArray(assignedTo)
          ? assignedTo
          : typeof assignedTo === "string"
            ? assignedTo
                .split(",")
                .map((name) => name.trim())
                .filter(Boolean)
            : [];

        return (
          <div className="avatar-list-stacked d-flex">
            {staffList.length > 0 ? (
              staffList.map((name, index) => {
                const color = avatarColors[index % avatarColors.length];

                return (
                  <span
                    key={`${name}-${index}`}
                    className="avatar avatar-rounded fw-bold d-flex justify-content-center align-items-center"
                    style={{
                      width: 35,
                      height: 35,
                      fontSize: 14,
                      backgroundColor: color.background,
                      color: color.color,
                    }}
                    title={name}
                  >
                    {name.charAt(0).toUpperCase()}
                  </span>
                );
              })
            ) : (
              <span className="text-muted">N/A</span>
            )}
          </div>
        );
      },

      sorter: (a, b) => {
        const getStaffCount = (staffNames) => {
          if (Array.isArray(staffNames)) {
            return staffNames.length;
          }

          if (typeof staffNames === "string") {
            return staffNames
              .split(",")
              .map((name) => name.trim())
              .filter(Boolean).length;
          }

          return 0;
        };

        return getStaffCount(a.staff_names) - getStaffCount(b.staff_names);
      },
    },

    {
      title: "Priority",
      dataIndex: "priority_name",

      sorter: (a, b) =>
        String(a.priority_name || "").localeCompare(
          String(b.priority_name || ""),
        ),

      render: (priorityName, record) => {
        const currentPriorityId = record.priority
          ? Number(record.priority)
          : undefined;

        const isRowUpdating = updatingPriorityTaskId === record.id;

        const getColor = (priority) => {
          switch (
            String(priority || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "low":
              return "#198754"; // green

            case "medium":
              return "#ffc107"; // yellow

            case "high":
              return "#fd7e14"; // orange

            case "urgent":
              return "#dc3545"; // red

            default:
              return "#6c757d"; // gray
          }
        };

        const selectedPriority = priorityOptions.find(
          (item) => Number(item.priorityid) === Number(currentPriorityId),
        );

        const priorityColor = getColor(selectedPriority?.name || priorityName);

        return (
          <Select
            value={selectedPriority ? currentPriorityId : undefined}
            size="small"
            loading={priorityOptionsLoading || isRowUpdating}
            disabled={isRowUpdating || priorityOptionsLoading}
            style={{
              width: 95,
            }}
            styles={{
              selector: {
                border: `1px solid ${priorityColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={priorityOptions.map((option) => ({
              value: option.priorityid,
              label: option.name,
            }))}
            onChange={(newPriorityId) => {
              if (Number(newPriorityId) === Number(currentPriorityId)) {
                return;
              }

              updateTaskPriority(record.id, newPriorityId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: priorityColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedPriority?.name || priorityName || "Select priority"}
                </span>
              </div>
            )}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                to="#"
                className="me-2 p-2  shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("view", record);
                }}
              >
                <i className="ti ti-eye text-info"></i>
              </Link>
              <Link
                to="#"
                className="me-2 p-2  shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
              <Link
                to="#"
                className="me-2 p-2 shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  setSelectedTaskId(record.id);
                  setFilesDrawerOpen(true);
                }}
                title="View Attachments"
              >
                <i className="ti ti-paperclip text-success"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [tasks, setTasks] = useState([]);
  const [taskloading, setTaskLoading] = useState(false);
  const [openAddTask, setOpenAddTask] = useState(false);

  const getTasks = async (leadId) => {
    try {
      console.log(leadId);
      setTaskLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}tasks/GetTasksnew?leadId=${leadId}`,
      );

      if (response.data.Status) {
        setTasks(response.data.ResultData || []);
      } else {
        setTasks([]);
      }
    } catch (error) {
      console.error("Get Tasks Error:", error);
      setTasks([]);
    } finally {
      setTaskLoading(false);
    }
  };

  const updateTaskStatus = async (taskId, statusId) => {
    try {
      setUpdatingStatusTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          status: statusId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update status");
      }

      message.success("Task status updated successfully");

      await Promise.all([getTasks(id)]);
    } catch (error) {
      console.error("Error updating task status:", error);

      message.error("Failed to update task status");
    } finally {
      setUpdatingStatusTaskId(null);
    }
  };

  const updateTaskPriority = async (taskId, priorityId) => {
    try {
      setUpdatingPriorityTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskPriority`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          priority: priorityId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update priority");
      }

      message.success("Task priority updated successfully");

      await getTasks(id);
    } catch (error) {
      console.error("Error updating task priority:", error);

      message.error("Failed to update task priority");
    } finally {
      setUpdatingPriorityTaskId(null);
    }
  };

  useEffect(() => {
    if (id) {
      getTasks(id);
    }
  }, [id]);

  useEffect(() => {
    fetchTaskStatuses();
    fetchPriorities();
  }, []);

  const [selectedLead, setSelectedLead] = useState(null);
  const [showCustomer, setShowCustomer] = useState(false);

  const handleConvertToCustomer = () => {
    setSelectedLead(leadsData);
    setShowCustomer(true);
  };

  const [detailDrawer, setDetailDrawer] = useState({
    open: false,
    mode: "view",
    taskId: null,
  });

  const openTaskDetail = (mode, record) => {
    setDetailDrawer({ open: true, mode, taskId: record?.id });
  };
  const closeTaskDetail = () => {
    setDetailDrawer((prev) => ({ ...prev, open: false }));
  };
  const handleEditTaskSuccess = async () => {
    setDetailDrawer((prev) => ({ ...prev, open: false }));
    await Promise.all([getTasks(id)]);
    message.success("Task updated successfully");
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <nav aria-label="breadcrumb">
          {/* <div className="d-flex justify-content-between align-items-center">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/crm/Dashboard">
                  <i className="fas fa-home fa-lg" />
                </Link>
              </li>
              <h4 className="breadcrumb-item mb-0" aria-current="page">
                View Leads - <b className="text-primary">{leadsData.company}</b>
              </h4>

              <ul
                className="nav nav-tabs nav-tabs-bottom mb-3"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "profile" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("profile")}
                    role="tab"
                  >
                    Profile
                  </Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "proposals" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("proposals")}
                    role="tab"
                  >
                    Proposals
                  </Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "task" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("task")}
                    role="tab"
                  >
                    Tasks
                  </Link>
                </li>

                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "reminders" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("reminders")}
                    role="tab"
                  >
                    Reminders
                  </Link>
                </li>
                <li className="nav-item" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "notes" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("notes")}
                    role="tab"
                  >
                    Notes
                  </Link>
                </li>
                <li className="nav-item d-none" role="presentation">
                  <Link
                    className={`nav-link ${
                      activeTab === "activitylog" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("activitylog")}
                    role="tab"
                  >
                    Activity Log
                  </Link>
                </li>
              </ul>
              <div className="d-flex">
                {activeTab === "profile" && (
                  <div>
                    {!isEditingProfile && (
                      <Link
                        type="button"
                        className="btn btn-success me-2"
                        onClick={handleConvertToCustomer}
                        title="convert to customer"
                      >
                        <i className="fas fa-user"></i>
                      </Link>
                    )}

                    <Link
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={handleEditClick}
                    >
                      <i className="fas fa-edit"></i>{" "}
                      {isEditingProfile ? "Cancel" : "Edit"}
                    </Link>
                  </div>
                )}

                <Link to="/crm/leads" className="btn btn-secondary me-2 mb-2">
                  <i className="ti ti-arrow-left"></i>
                </Link>
              </div>
            </ol>
          </div> */}
          <div className="d-flex align-items-center justify-content-between mb-3">
            {/* Left: Breadcrumb + Title */}
            <div className="d-flex align-items-center">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/crm/Dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <li className="breadcrumb-item mb-0" aria-current="page">
                  View Leads
                  {/* <b className="text-primary">{leadsData.company}</b> */}
                </li>
              </ol>
            </div>

            {/* Center: Tabs */}
            <ul
              className="nav nav-tabs nav-tabs-bottom mb-0"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "profile" ? "active" : ""
                  }`}
                  // onClick={() => setActiveTab("profile")}
                  onClick={() => handleTabChange("profile")}
                  role="tab"
                >
                  Profile
                </Link>
              </li>

              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "proposals" ? "active" : ""
                  }`}
                  // onClick={() => setActiveTab("proposals")}
                  onClick={() => handleTabChange("proposals")}
                  role="tab"
                >
                  Proposals
                </Link>
              </li>

              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${activeTab === "task" ? "active" : ""}`}
                  // onClick={() => setActiveTab("task")}
                  onClick={() => handleTabChange("task")}
                  role="tab"
                >
                  Tasks
                </Link>
              </li>

              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "reminders" ? "active" : ""
                  }`}
                  // onClick={() => setActiveTab("reminders")}
                  onClick={() => handleTabChange("reminders")}
                  role="tab"
                >
                  Reminders
                </Link>
              </li>

              <li className="nav-item" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "notes" ? "active" : ""
                  }`}
                  // onClick={() => setActiveTab("notes")}
                  onClick={() => handleTabChange("notes")}
                  role="tab"
                >
                  Notes
                </Link>
              </li>

              <li className="nav-item d-none" role="presentation">
                <Link
                  className={`nav-link ${
                    activeTab === "activitylog" ? "active" : ""
                  }`}
                  // onClick={() => setActiveTab("activitylog")}
                  onClick={() => handleTabChange("activitylog")}
                  role="tab"
                >
                  Activity Log
                </Link>
              </li>
            </ul>

            {/* Right: Edit + Convert + Back */}
            <div className="d-flex align-items-center">
              {activeTab === "profile" && (
                <>
                  {!isEditingProfile && (
                    <Link
                      type="button"
                      className="btn btn-success btn-sm me-2"
                      onClick={handleConvertToCustomer}
                      title="Convert to customer"
                    >
                      <i className="fas fa-user"></i>
                    </Link>
                  )}

                  <Link
                    type="button"
                    className="btn btn-secondary btn-sm me-2"
                    onClick={handleEditClick}
                  >
                    <i className="fas fa-edit"></i>{" "}
                    {isEditingProfile ? "Cancel" : "Edit"}
                  </Link>
                </>
              )}

              <Link
                to="/crm/leads"
                className="btn btn-secondary btn-sm"
                title="Back to leads"
              >
                <i className="ti ti-arrow-left"></i>
              </Link>
            </div>
          </div>
        </nav>
        <div className="mt-2">
          <div className="card shadow proposal-summary">
            <div className="card-body pb-1 ">
              <div className="row align-items-center">
                <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                  <div className="d-inline-flex align-items-center">
                    <span className="fw-bold me-2">Lead No:</span>
                    <span className="fw-bold text-danger">
                      #{leadsData.id || "-"}
                    </span>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                  <div className="d-inline-flex align-items-center">
                    {/* <i className="fa-regular fa-clock  me-2"></i> */}
                    <span className="fw-bold me-2">Company:</span>
                    <span className="fw-bold">{leadsData.company || "-"}</span>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                  <div className="d-inline-flex align-items-center">
                    <i className="fa-regular fa-calendar me-2"></i>
                    <span className="fw-bold me-2">Created On:</span>
                    <span className="fw-bold">
                      {dayjs(leadsData.dateassigned || "-").format(
                        "DD-MM-YYYY",
                      )}
                    </span>
                  </div>
                </div>

                <div className="col-md-3 col-sm-6 mb-2 text-center">
                  <div className="d-inline-flex align-items-center">
                    {/* <i className="fa-solid fa-indian-rupee-sign me-2"></i> */}
                    <span className="fw-bold me-2">Phone:</span>
                    <span className="fw-bold text-success">
                      {leadsData.phonenumber || "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card shadow mb-4">
            <div className="card-body">
              <div className="tab-content px-3">
                {activeTab === "profile" && (
                  <>
                    {isEditingProfile ? (
                      <Spin
                        spinning={updating}
                        // tip="Loading lead details..."
                        size="large"
                      >
                        <form>
                          <div className="row mb-3">
                            <div className="col-3">
                              <label className="form-label">Status</label>

                              <Select
                                className="w-100"
                                placeholder="Status"
                                options={statusOptions}
                                value={formData.status}
                                onChange={(value) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    status: value,
                                  }))
                                }
                                loading={statusLoading}
                                style={{ height: 38 }}
                              />
                            </div>
                            <div className="col-3">
                              <label className="form-label">Source</label>
                              <Select
                                placeholder="Source"
                                style={{ height: 38 }}
                                options={sourceOptions}
                                value={formData.source}
                                onChange={(value) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    source: value,
                                  }))
                                }
                                className="w-100"
                                loading={sourceLoading}
                              />
                            </div>
                            <div className="col-3">
                              <label className="form-label">Assigned</label>
                              <Select
                                placeholder="Assigned To"
                                options={assignedOptions}
                                style={{ height: 38 }}
                                value={formData.assigned}
                                onChange={(value) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    assigned: value,
                                  }))
                                }
                                className="w-100"
                                loading={staffLoading}
                              />
                            </div>

                            <div className="col-3">
                              <label className="form-label">Country</label>
                              <Select
                                options={countryOptions}
                                style={{ height: 38 }}
                                className="w-100"
                                value={formData.country}
                                onChange={(value) =>
                                  setFormData((prev) => ({
                                    ...prev,
                                    country: value,
                                  }))
                                }
                              />
                            </div>
                          </div>
                          <hr className="w-100" />
                          <div className="row">
                            <div className="col-md-3 mb-3">
                              <label>Name</label>
                              <input
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Address</label>
                              <input
                                type="text"
                                name="address"
                                placeholder="Enter address"
                                className="form-control"
                                value={formData.address}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Position</label>
                              <input
                                type="text"
                                name="title"
                                className="form-control"
                                placeholder="Enter Position"
                                value={formData.title}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>City</label>
                              <input
                                type="text"
                                placeholder="Enter City"
                                name="city"
                                className="form-control"
                                value={formData.city}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Email</label>
                              <input
                                type="email"
                                placeholder="Enter Emial"
                                name="email"
                                className="form-control"
                                value={formData.email}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>State</label>
                              <input
                                type="text"
                                name="state"
                                placeholder="Enter State"
                                className="form-control"
                                value={formData.state}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Website</label>
                              <input
                                type="text"
                                placeholder="Enter Website"
                                name="website"
                                className="form-control"
                                value={formData.website}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="col-md-3 mb-3">
                              <label>Phone</label>
                              <input
                                type="text"
                                name="phonenumber"
                                placeholder="Enter Phone Number"
                                className="form-control"
                                value={formData.phonenumber}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Zip Code</label>
                              <input
                                type="text"
                                placeholder="Enter Zip code"
                                name="zip"
                                className="form-control"
                                value={formData.zip}
                                onChange={handleChange}
                              />
                            </div>

                            {/* New Fields */}
                            <div className="col-md-3 mb-3">
                              <label>Lead Value</label>
                              <input
                                type="number"
                                placeholder="Enter Lead Value"
                                className="form-control"
                                name="leadvalue"
                                value={formData.leadvalue}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Language</label>
                              <input
                                type="text"
                                className="form-control"
                                name="default_language"
                                value={formData.default_language}
                                onChange={handleChange}
                                placeholder="Enter language"
                              />
                            </div>
                            <div className="col-md-3 mb-3">
                              <label>Company Name</label>
                              <input
                                type="text"
                                placeholder="Enter Company Name"
                                name="company"
                                className="form-control"
                                value={formData.company}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-3 mb-3">
                              <label className="form-label">Last Contact</label>
                              <DatePicker
                                placeholder="Enter Last Contact"
                                className="form-control"
                                format="DD-MM-YYYY"
                                value={
                                  leadsData?.lastcontact
                                    ? dayjs(leadsData.lastcontact)
                                    : null
                                }
                              />
                            </div>

                            <div className="col-9 mb-3">
                              <label>Description</label>
                              <textarea
                                className="form-control"
                                name="description"
                                placeholder="enter description"
                                rows="3"
                                value={formData.description}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                          <div className="d-flex align-items-center w-100">
                            <div className="d-flex align-items-center gap-2 text-end ms-auto">
                              {/* <button
                            type="button"
                            className="btn btn-light me-2"
                            onClick={handleCancelReminderEdit}
                          >
                            Close
                          </button> */}

                              <button
                                type="button"
                                onClick={handleCancelReminderEdit}
                                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#e40d22",
                                  color: "#fff",
                                  border: "none",
                                }}
                                title="Cancel"
                              >
                                <i className="fa fa-times" />
                              </button>

                              {/* <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={updateLead}
                            disabled={updating}
                          >
                            {updating ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Updating...
                              </>
                            ) : (
                              "Save"
                            )}
                          </button> */}

                              <button
                                type="submit"
                                onClick={updateLead}
                                disabled={updating}
                                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#07f083",
                                  color: "#fff",
                                  border: "none",
                                }}
                                title="Save"
                              >
                                {updating ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  />
                                ) : (
                                  <i className="fa fa-check" />
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      </Spin>
                    ) : (
                      <Spin
                        spinning={viewLeadLoading}
                        // tip="Loading lead details..."
                        size="large"
                      >
                        <div className="mt-1" style={{ marginTop: "-2rem" }}>
                          <div className="row">
                            <div className="col-md-6">
                              <h5>Lead Information</h5>
                              <dl className="row">
                                <dt className="col-sm-4">Name:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.name || "-"}
                                </dd>

                                <dt className="col-sm-4">Position:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.title || "-"}
                                </dd>

                                <dt className="col-sm-4">Email Address:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.email || "-"}
                                </dd>

                                <dt className="col-sm-4">Website:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.website || "-"}
                                </dd>

                                <dt className="col-sm-4">Phone:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.phonenumber || "-"}
                                </dd>

                                <dt className="col-sm-4">Lead Value:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.lead_value || "-"}
                                </dd>

                                <dt className="col-sm-4">Company:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.company || "-"}
                                </dd>

                                <dt className="col-sm-4">Address:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.address || "-"}
                                </dd>

                                <dt className="col-sm-4">City:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.city || "-"}
                                </dd>

                                <dt className="col-sm-4">State:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.state || "-"}
                                </dd>

                                <dt className="col-sm-4">Country:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.CountryName || "-"}
                                </dd>

                                <dt className="col-sm-4">Zip Code:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.zip || "-"}
                                </dd>
                              </dl>
                            </div>

                            <div className="col-md-6">
                              <h5>General Information</h5>
                              <dl className="row">
                                <dt className="col-sm-4">Status:</dt>
                                <dd className="col-sm-8">
                                  <span className="badge bg-light border-2">
                                    {leadsData.StatusName || "-"}
                                  </span>
                                </dd>

                                <dt className="col-sm-4">Source:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.SourceName || "-"}
                                </dd>

                                <dt className="col-sm-4">Language:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.default_language || "-"}
                                </dd>

                                <dt className="col-sm-4">Assigned:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.AssignedTo || "-"}
                                </dd>

                                {/* <dt className="col-sm-4">Tags:</dt>
                              <dd className="col-sm-8">
                                {leadsData.tags || "-"}
                              </dd> */}

                                <dt className="col-sm-4">Created:</dt>
                                <dd className="col-sm-8">
                                  {dayjs(leadsData.dateadded).format(
                                    "DD-MM-YYYY",
                                  ) || "-"}
                                </dd>

                                <dt className="col-sm-4">Last Contact:</dt>
                                <dd className="col-sm-8">
                                  {dayjs(leadsData.lastcontact).format(
                                    "DD-MM-YYYY",
                                  ) || "-"}
                                </dd>

                                <dt className="col-sm-4">Public:</dt>
                                <dd className="col-sm-8">
                                  {leadsData.public ? "Yes" : "No"}
                                </dd>
                              </dl>
                            </div>
                          </div>

                          <div className="mt-3">
                            <h5>Description</h5>
                            <p>{leadsData.description}</p>
                          </div>

                          <div className="mt-3 p-2 bg-light border">
                            <h5>Latest Activity</h5>
                            <p>
                              <small>{leadsData.AssignedTo}-created Lead</small>
                            </p>
                          </div>
                        </div>
                      </Spin>
                    )}
                  </>
                )}
                {activeTab === "proposals" && (
                  <>
                    <div
                      className="d-flex justify-content-between my-0"
                      style={{ marginTop: "-2rem" }}
                    ></div>
                    <div className="card table-list-card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set"></div>
                        <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                          <div className="d-flex justify-content-end">
                            <div className="me-3 ">
                              <Link
                                to="/crm/add/proposal"
                                className="btn btn-success btn-sm"
                                state={{
                                  type: "lead",
                                  customerId: leadsData.id,
                                  record: leadsData,
                                }}
                              >
                                <i className="ti ti-circle-plus fs-4 "> </i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          {/* <Table
                            columns={proposalColumns}
                            dataSource={proposals}
                            loading={proposalsLoading}
                          /> */}

                          {loading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "250px", // adjust height if needed
                              }}
                            >
                              <Spin size="large" />
                            </div>
                          ) : (
                            <Table
                              columns={proposalColumns}
                              dataSource={proposals}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {activeTab === "task" && (
                  <>
                    <div
                      className="d-flex justify-content-between my-0"
                      style={{ marginTop: "-2rem" }}
                    ></div>
                    <div className="card table-list-card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set"></div>
                        <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                          <div className="dropdown me-2"></div>
                          <div className="d-flex justify-content-end">
                            <div className="me-3">
                              <Link
                                to="#"
                                onClick={() => setOpenAddTask(true)}
                                className="btn btn-success btn-sm"
                              >
                                <i className="ti ti-circle-plus fs-4"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          {/* <Spin spinning={taskloading} tip="Loading tasks..."> */}
                          {/* <Table
                            columns={columns}
                            dataSource={tasks}
                            loading={taskloading}
                            rowKey="id"
                            pagination={false} // optional
                          /> */}
                          {/* </Spin> */}
                          {taskloading ? (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "250px", // adjust height if needed
                              }}
                            >
                              <Spin size="large" />
                            </div>
                          ) : (
                            <Table columns={columns} dataSource={tasks} />
                          )}
                        </div>
                      </div>

                      <NewTask
                        open={openAddTask}
                        onClose={() => setOpenAddTask(false)}
                        type="lead"
                        id={id}
                        onSuccess={async () => {
                          setOpenAddTask(false);

                          await getTasks(id);
                        }}
                      />

                      <TaskDetailDrawer
                        mode={detailDrawer.mode}
                        taskId={detailDrawer.taskId}
                        open={detailDrawer.open}
                        onClose={closeTaskDetail}
                        onSuccess={handleEditTaskSuccess}
                        type="lead"
                        id={id}
                      />
                    </div>
                  </>
                )}
                {activeTab === "attachments" && (
                  <div className="mt-1">
                    <div className="row">
                      <div className="col-12">
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{
                            border: "2px dashed #007bff",
                            padding: "40px",
                            textAlign: "center",
                          }}
                        >
                          <a
                            href="#"
                            style={{ fontSize: "18px", color: "#007bff" }}
                          >
                            Drag files here to upload
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === "reminders" && (
                  <>
                    <div className="container">
                      {editingReminderId === null && (
                        <>
                          <div className="row align-items-end g-2">
                            <div className="col-md-5">
                              <Input.TextArea
                                rows={1}
                                autoSize={{ minRows: 1, maxRows: 2 }}
                                placeholder="Reminder description"
                                value={reminderData.description}
                                onChange={(e) =>
                                  setReminderData((prev) => ({
                                    ...prev,
                                    description: e.target.value,
                                  }))
                                }
                              />
                            </div>

                            <div className="col-md-3">
                              <DatePicker
                                showTime
                                className="w-100"
                                style={{ height: 38 }}
                                value={reminderData.date}
                                onChange={(value) =>
                                  setReminderData((prev) => ({
                                    ...prev,
                                    date: value,
                                  }))
                                }
                                suffixIcon={<CalendarOutlined />}
                              />
                            </div>

                            <div className="col-md-3">
                              <TagSelector
                                className="w-100"
                                style={{ height: 38 }}
                                placeholder="Select Staff"
                                loading={staffLoading}
                                value={reminderData.staff}
                                onChange={(value) =>
                                  setReminderData((prev) => ({
                                    ...prev,
                                    staff: value,
                                  }))
                                }
                                showSearch
                                optionFilterProp="label"
                                options={staffList.map((staff) => ({
                                  value: staff.staffid,
                                  label: `${staff.firstname} ${staff.lastname}`,
                                }))}
                              />
                            </div>

                            <div className="col-md-1 d-flex align-items-center gap-2">
                              <button
                                type="button"
                                onClick={handelCancelreminder}
                                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#e40d22",
                                  color: "#fff",
                                  border: "none",
                                }}
                                title="Cancel"
                              >
                                <i className="fa fa-times" />
                              </button>

                              <button
                                type="submit"
                                onClick={handleAddReminder}
                                disabled={addReminderLoading}
                                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  backgroundColor: "#07f083",
                                  color: "#fff",
                                  border: "none",
                                }}
                                title="Save"
                              >
                                {addReminderLoading ? (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  />
                                ) : (
                                  <i className="fa fa-check" />
                                )}
                              </button>
                            </div>
                          </div>
                        </>
                      )}
                      {remindersLoading ? (
                        <div className="text-center py-4">
                          <Spin />
                        </div>
                      ) : reminders.length > 0 ? (
                        reminders.map((reminder) => {
                          const isCompleted = Number(reminder.isnotified) === 1;

                          return (
                            <div
                              className="card shadow-lg border-0 mt-3"
                              key={reminder.id}
                            >
                              <div className="card-body">
                                {editingReminderId === reminder.id ? (
                                  <>
                                    <Input.TextArea
                                      rows={4}
                                      value={editReminderData.description}
                                      onChange={(e) =>
                                        setEditReminderData((prev) => ({
                                          ...prev,
                                          description: e.target.value,
                                        }))
                                      }
                                    />
                                    <div className="row">
                                      <div className="col-6">
                                        <DatePicker
                                          showTime
                                          className="w-100 mt-3"
                                          value={editReminderData.date}
                                          onChange={(value) =>
                                            setEditReminderData((prev) => ({
                                              ...prev,
                                              date: value,
                                            }))
                                          }
                                          suffixIcon={<CalendarOutlined />}
                                        />
                                      </div>
                                      <div className="col-6">
                                        <TagSelector
                                          className="w-100 mt-3"
                                          style={{ height: 38 }}
                                          value={editReminderData.isnotified}
                                          onChange={(value) =>
                                            setEditReminderData((prev) => ({
                                              ...prev,
                                              isnotified: Number(value),
                                            }))
                                          }
                                          options={[
                                            {
                                              value: 1,
                                              label: (
                                                <span className=" fw-semibold">
                                                  Completed
                                                </span>
                                              ),
                                            },
                                            {
                                              value: 0,
                                              label: (
                                                <span className=" fw-semibold">
                                                  Pending
                                                </span>
                                              ),
                                            },
                                          ]}
                                        />
                                      </div>
                                    </div>

                                    <div className="text-end mt-3">
                                      {/* <button
                                        className="btn btn-light me-2"
                                        onClick={handleCancelReminderEdit}
                                      >
                                        Cancel
                                      </button>

                                      <button
                                        className="btn btn-primary"
                                        onClick={handleUpdateReminder}
                                        disabled={updateReminderLoading}
                                      >
                                        {updateReminderLoading
                                          ? "Updating..."
                                          : "Update"}
                                      </button> */}

                                      <div className="col-md-1 d-flex align-items-center gap-2  ms-auto">
                                        <button
                                          type="button"
                                          onClick={handleCancelReminderEdit}
                                          className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                            backgroundColor: "#e40d22",
                                            color: "#fff",
                                            border: "none",
                                          }}
                                          title="Cancel"
                                        >
                                          <i className="fa fa-times" />
                                        </button>

                                        <button
                                          type="submit"
                                          onClick={handleUpdateReminder}
                                          disabled={updateReminderLoading}
                                          className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                          style={{
                                            width: "35px",
                                            height: "35px",
                                            backgroundColor: "#07f083",
                                            color: "#fff",
                                            border: "none",
                                          }}
                                          title="Update"
                                        >
                                          {updateReminderLoading ? (
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                            />
                                          ) : (
                                            <i className="fa fa-check" />
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p>{reminder.description}</p>

                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center flex-wrap gap-3">
                                        <small className="text-muted">
                                          <i className="fa fa-user me-2"></i>
                                          {`${reminder.firstname} ${reminder.lastname}`}
                                        </small>

                                        <small className="text-muted">
                                          <i className="fa fa-calendar me-2"></i>
                                          {dayjs(reminder.date).format(
                                            "DD-MM-YYYY hh:mm A",
                                          )}
                                        </small>

                                        {/* Status Badge */}
                                        <small
                                          className={`badge ${
                                            isCompleted
                                              ? "bg-success-subtle text-success"
                                              : "bg-danger-subtle text-danger"
                                          }`}
                                          style={{
                                            borderRadius: "8px",
                                            padding: "5px 10px",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {isCompleted
                                            ? "Completed"
                                            : "Pending"}
                                        </small>
                                      </div>

                                      <div className="d-flex justify-content-between gap-2">
                                        <button
                                          className="btn btn-sm btn-outline-primary"
                                          onClick={() =>
                                            handleEditReminder(reminder)
                                          }
                                        >
                                          <i className="fa fa-edit"></i>
                                        </button>
                                        <button
                                          className="btn btn-sm btn-outline-danger"
                                          onClick={() =>
                                            handleDeleteReminder(reminder.id)
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <Empty description="No reminders found" />
                      )}
                    </div>
                  </>
                )}

                {activeTab === "notes" && (
                  <div className="container mt-1">
                    <div className="row">
                      {notesLoading ? (
                        <div className="text-center py-3">
                          <Spin />
                        </div>
                      ) : (
                        <>
                          {/* Add Note Form */}
                          {editingNoteId === null && (
                            <>
                              <div className="row">
                                <div className="col-11">
                                  <textarea
                                    className="form-control"
                                    rows="3"
                                    placeholder="Enter your note here..."
                                    value={noteData.description}
                                    onChange={(e) =>
                                      setNoteData((prev) => ({
                                        ...prev,
                                        description: e.target.value,
                                      }))
                                    }
                                  />
                                </div>

                                <div className="col-1 mt-5">
                                  {/* <button
                                  className="btn btn-primary"
                                  onClick={handleAddNote}
                                  disabled={addNoteLoading}
                                >
                                  {addNoteLoading ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm me-2"></span>
                                      Adding...
                                    </>
                                  ) : (
                                    "Add"
                                  )}
                                </button> */}

                                  <div className="d-flex align-items-center gap-2">
                                    {/* Close Drawer */}
                                    <button
                                      type="button"
                                      onClick={handelCancelNote}
                                      className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        backgroundColor: "#e40d22",
                                        color: "#fff",
                                        border: "none",
                                      }}
                                      title="Close"
                                    >
                                      <i className="fa fa-times" />
                                    </button>

                                    {/* Save */}
                                    <button
                                      type="button"
                                      onClick={handleAddNote}
                                      disabled={addNoteLoading}
                                      className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        backgroundColor: "#07f083",
                                        color: "#fff",
                                        border: "none",
                                      }}
                                      title="Save"
                                    >
                                      {addNoteLoading ? (
                                        <span
                                          className="spinner-border spinner-border-sm"
                                          role="status"
                                        />
                                      ) : (
                                        <i className="fa fa-check" />
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}

                          {/* Notes List or Empty */}
                          {notes.length > 0 ? (
                            <div className="mt-2">
                              {notes.map((note) => (
                                <div
                                  key={note.id}
                                  className="card border shadow-lg mb-3"
                                >
                                  <div className="card-body">
                                    {editingNoteId === note.id ? (
                                      <>
                                        <textarea
                                          rows={3}
                                          className="form-control mb-3"
                                          value={editNoteData.description}
                                          onChange={(e) =>
                                            setEditNoteData({
                                              description: e.target.value,
                                            })
                                          }
                                        />

                                        <div className="d-flex justify-content-end gap-2">
                                          {/* <button
                                            className="btn btn-light"
                                            onClick={handleCancelEdit}
                                            disabled={updateNoteLoading}
                                          >
                                            Cancel
                                          </button>

                                          <button
                                            className="btn btn-primary"
                                            onClick={handleUpdateNote}
                                            disabled={updateNoteLoading}
                                          >
                                            {updateNoteLoading ? (
                                              <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Updating...
                                              </>
                                            ) : (
                                              "Update"
                                            )}
                                          </button> */}

                                          <div className="d-flex align-items-center gap-2">
                                            {/* Close Drawer */}
                                            <button
                                              type="button"
                                              onClick={handleCancelEdit}
                                              disabled={updateNoteLoading}
                                              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                              style={{
                                                width: "35px",
                                                height: "35px",
                                                backgroundColor: "#e40d22",
                                                color: "#fff",
                                                border: "none",
                                              }}
                                              title="Close"
                                            >
                                              <i className="fa fa-times" />
                                            </button>

                                            {/* Save */}
                                            <button
                                              type="button"
                                              onClick={handleUpdateNote}
                                              disabled={updateNoteLoading}
                                              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                                              style={{
                                                width: "35px",
                                                height: "35px",
                                                backgroundColor: "#07f083",
                                                color: "#fff",
                                                border: "none",
                                              }}
                                              title="Update"
                                            >
                                              {updateNoteLoading ? (
                                                <span
                                                  className="spinner-border spinner-border-sm"
                                                  role="status"
                                                />
                                              ) : (
                                                <i className="fa fa-check" />
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="d-flex justify-content-between">
                                          <p className="mb-2">
                                            {note.description}
                                          </p>
                                          <button
                                            className="btn btn-sm btn-outline-primary btn-icon"
                                            onClick={() => handleEditNote(note)}
                                          >
                                            <i className="fa-solid fa-pen-to-square"></i>
                                          </button>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center">
                                          <div>
                                            <small className="text-muted me-3">
                                              <i className="fa-regular fa-user me-2"></i>
                                              {note.added_by_name}
                                            </small>

                                            <small className="text-muted">
                                              <i className="fa-regular fa-calendar me-2"></i>
                                              {dayjs(note.dateadded).format(
                                                "DD-MM-YYYY hh:mm A",
                                              )}
                                            </small>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="col-12">
                              <Empty description="No notes found" />
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}

                {activeTab === "activitylog" && (
                  <div className="container mt-3">
                    {activityLoading ? (
                      <div className="text-center py-5">
                        <Spin size="large" />
                      </div>
                    ) : (
                      <div className="card border-0 shadow-sm">
                        <div className="card-body">
                          <div className="row align-items-center">
                            {/* User Info */}
                            <div className="col-md-4 border-end">
                              <div className="d-flex align-items-center">
                                <img
                                  src={img1}
                                  alt="User"
                                  className="rounded-circle me-3"
                                  style={{ width: 55, height: 55 }}
                                />

                                <div>
                                  <h6 className="mb-1 fw-bold">
                                    {activityLog.StaffName || "Unknown User"}
                                  </h6>

                                  <small className="text-muted d-block">
                                    {dayjs(activityLog.date).format(
                                      "DD MMM YYYY",
                                    )}
                                  </small>

                                  <small className="text-muted">
                                    {dayjs(activityLog.date).format("hh:mm A")}
                                  </small>
                                </div>
                              </div>
                            </div>

                            {/* Activity Details */}
                            <div className="col-md-8">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span className="badge bg-success">
                                  Activity
                                </span>

                                {/* <small className="text-muted">
                                  #{activityLog.id}
                                </small> */}
                              </div>

                              <h6 className="fw-semibold mb-3">
                                {activityLog.description}
                              </h6>

                              {/* {activityLog.additional_data && (
                                <div className="row g-3">
                                  <div className="col-md-6">
                                    <div className="border rounded p-3 bg-light">
                                      <small className="text-muted d-block">
                                        Status Changed To
                                      </small>

                                      <strong>
                                        {
                                          JSON.parse(
                                            activityLog.additional_data
                                          ).StatusName
                                        }
                                      </strong>
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="border rounded p-3 bg-light">
                                      <small className="text-muted d-block">
                                        Lead ID
                                      </small>

                                      <strong>{activityLog.leadid}</strong>
                                    </div>
                                  </div>
                                </div>
                              )} */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        <NewCustomer
          show={showCustomer}
          onClose={() => {
            setShowCustomer(false);
            setSelectedLead(null);
          }}
          leadData={selectedLead}
          isConvert={true}
        />
        <SetARemind />

        <FilesDrawer
          open={filesDrawerOpen}
          onClose={() => {
            setFilesDrawerOpen(false);
            setSelectedTaskId(null);
          }}
          relId={selectedTaskId}
          relType="task"
        />
      </>
    </div>
  );
};

export default ViewLeads;
